import { LogoDefault } from './LogoDefault.js';

export const LogoCharacter = (origin, slug) => {
    let src;
    try {
        src = require(`../../assets/images/characters/${origin}/${slug}/icon/${slug}.webp`);
    } catch (e) {
        if (e.code !== 'MODULE_NOT_FOUND') {
            throw e;
        }
        src = LogoDefault();
    }
    return src;
}